/* tslint:disable */

declare var Object: any;
export interface PlayerVersionInterface {
  "id": string;
  "platform": string;
  "version": string;
  "fileSize"?: number;
  "enabled": boolean;
  "filename"?: string;
  "url"?: string;
  "filenameOnServer"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class PlayerVersion implements PlayerVersionInterface {
  "id": string;
  "platform": string;
  "version": string;
  "fileSize": number;
  "enabled": boolean;
  "filename": string;
  "url": string;
  "filenameOnServer": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: PlayerVersionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerVersion`.
   */
  public static getModelName() {
    return "PlayerVersion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerVersion for dynamic purposes.
  **/
  public static factory(data: PlayerVersionInterface): PlayerVersion{
    return new PlayerVersion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerVersion',
      plural: 'PlayerVersions',
      path: 'PlayerVersions',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "platform": {
          name: 'platform',
          type: 'string'
        },
        "version": {
          name: 'version',
          type: 'string'
        },
        "fileSize": {
          name: 'fileSize',
          type: 'number',
          default: 0
        },
        "enabled": {
          name: 'enabled',
          type: 'boolean',
          default: true
        },
        "filename": {
          name: 'filename',
          type: 'string'
        },
        "url": {
          name: 'url',
          type: 'string'
        },
        "filenameOnServer": {
          name: 'filenameOnServer',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/PlayerVersion.ts